import * as AuthService from "~/services/AuthService";
import { queryClient } from "./queryClient";

/**
 * The signed-in user's identity comes from the API, not from a cookie -- the session
 * cookie is HttpOnly and unreadable by JavaScript.
 */
export const currentUserQueryKey = ["currentUser"];

export const fetchCurrentUser = async (): Promise<AuthService.IUserResponse> => {
  const { data } = await AuthService.getUser();
  return data;
};

export const currentUserQueryOptions = {
  queryKey: currentUserQueryKey,
  queryFn: fetchCurrentUser,
};

/**
 * For use outside React (route loaders, plain async helpers). Resolves from the cache
 * when it is warm, so this does not add a request per call site.
 */
export const ensureCurrentUser = (): Promise<AuthService.IUserResponse> =>
  queryClient.ensureQueryData(currentUserQueryOptions);

/**
 * Clears the whole query cache, not just the user. Called when the session changes
 * (login, logout, expiry) so no data from the previous session survives into the next.
 */
export const clearCurrentUser = () => {
  queryClient.clear();
};
